import React from 'react';
import PropTypes from 'prop-types';
import SupportTag from '../common/SupportTag';

export default function AppDetailsAuthorsMeta({ supportedBy, company, onClickLink }) {
    return (
        <div className="ast-app-details__header-app-meta">
            <SupportTag supportedBy={supportedBy} />
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>
                Created by&nbsp;
                {company.website ? (
                    <a href={company.website} target="_blank" rel="noreferrer" onClick={onClickLink}>
                        {company.name}
                    </a>
                ) : (
                    company.name
                )}
            </span>
        </div>
    );
}

AppDetailsAuthorsMeta.propTypes = {
    supportedBy: PropTypes.string.isRequired,
    company: PropTypes.shape({
        website: PropTypes.string,
        name: PropTypes.string.isRequired,
    }).isRequired,
    onClickLink: PropTypes.func.isRequired,
};
